import React from 'react'
import { Carousel, Row, Col } from 'antd'
import DeferImage from '../DeferImage'

const reasons = [
  {
    title: 'Finding a good provider can be difficult',
    description:
      'With so many available, how do you know which one will give you the best car care?',
    image: 'assets/images/confused-user.svg',
    imageAlt: 'Confused user'
  },
  {
    title: 'We know what to look for',
    description:
      'We help you choose the right shop to give your car the best service at a cost efficient price!',
    image: 'assets/images/knowledgeable-employee.png',
    imageAlt: 'Knowledgeable employee'
  },
  {
    title: 'You save time and feel refreshed!',
    description:
      'Not everyone has the time to service their car. With AutoMech, we take care of your car, so you worry less and save time!',
    image: 'assets/images/satisfied-customer-with-helpful-employee.svg',
    imageAlt: 'Satisifed customer with helpful employee'
  }
]
const WhyUs = () => (
  <section
    className="hero is-info section-padding"
    style={{ backgroundColor: '#1188D8', color: 'white' }}
  >
    <div>
      <h1 className="subtitle is-2 has-text-centered">Why? We love and know cars!</h1>
    </div>
    <div>
      <Carousel>{reasons.map((reason, index) => renderWhyUsSlide(reason, index))}</Carousel>
      <figure className="image">
        <DeferImage
          src="assets/images/car-gears-tools-wallpaper.svg"
          alt="Cars, gears, and tools wallpaper"
        />
      </figure>
    </div>
  </section>
)

const renderWhyUsSlide = reason => {
  return (
    <div key={reason.title}>
      <Row type="flex" justify="center" align="middle" style={{ paddingBottom: '3em' }}>
        <Col md={6} />
        <Col md={8}>
          <div style={{ textAlign: 'center' }}>
            <h2 className="subtitle is-3 has-text-white">{reason.title}</h2>
            <span className="has-text-weight-semibold has-text-white" style={{ fontSize: '1rem' }}>
              {reason.description}
            </span>
          </div>
        </Col>
        <Col md={10}>
          <DeferImage src={reason.image} className="why-image" alt={reason.imageAlt} />
        </Col>
      </Row>
    </div>
  )
}
export default WhyUs



// WEBPACK FOOTER //
// ./src/components/home/WhyUs.js